<div class="loginForm">
  <div class="homeBox mb-4">
    <img alt="logo" class="imgLogo" src="/assets/logo_ingein.png">
    <h1 class="titleh1 w-100">Inspecciones</h1>
  </div>
  <form [formGroup]="form" class="text-center">
    <!-- <div>
      <div class="label">Usuario:</div>
      <input #username type="text" formControlName="UserName" />
    </div>
    <div>
      <div class="label">Contraseña:</div>
      <input type="password" formControlName="Password" />
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{errorMessage}}
    </div>
    <div>
      <button type="submit" [disabled]="!form.valid" (click)="login()">Entrar</button>
    </div> -->
    <div class="form-group">
      <label class="labelItem">Nombre de usuario</label>
      <input #username type="text" formControlName="UserName" placeholder="Usuario"/>
    </div>
    <div class="form-group position-relative mt-2">
      <label class="labelItem">Contraseña</label>
      <input #password type="password" formControlName="Password" placeholder="Contraseña"/>
      <span class="iconEyes">
        <ion-icon name="eye" style="cursor: pointer;" (click)="toggleVisibility(password)"></ion-icon>
        <!--change icon 'eye-off-sharp'-->
      </span>
    </div>
    <div *ngIf="errorMessage" >
      <span class="error-message">
        {{errorMessage}}
      </span>
     
    </div>
    <div class="mt-3">
      <ion-button type="submit" class="btn1 " [disabled]="!form.valid" (click)="login()">Entrar</ion-button>
    </div> 
    <!-- <div class="mt-3">
      <a class="btn-link">Recuperar contraseña</a>
    </div> -->
  </form>
</div>